import { FaPlay, FaList, FaCar } from 'react-icons/fa'

export const simulatorMenuItems = [
  {
    id: 'TAB1',
    title: 'Avant de démarrer',
    short: 'Avant de démarrer',
    icon: FaPlay,
  },
  {
    id: 'TAB2',
    title: 'Générer la liste de produits',
    short: 'Simulateur de produits',
    icon: FaList,
  },
  {
    id: 'TAB3',
    title: 'Générer la liste des véhicules',
    short: 'Simulateur de véhicules',
    icon: FaCar,
  },
]
